var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemoveFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.375 9.375L13.125 13.125M13.125 9.375L9.375 13.125M6.25 13.125V9.16419C6.25 9.01137 6.25 8.93494 6.23273 8.863C6.21742 8.79919 6.19217 8.73825 6.1579 8.68231C6.11925 8.61925 6.0652 8.56519 5.95711 8.45712L2.16789 4.66789C2.0598 4.5598 2.00575 4.50575 1.9671 4.44268C1.93283 4.38676 1.90758 4.32579 1.89227 4.26202C1.875 4.19009 1.875 4.11366 1.875 3.96079V2.875C1.875 2.52497 1.875 2.34995 1.94312 2.21626C2.00304 2.09866 2.09866 2.00304 2.21626 1.94312C2.34995 1.875 2.52497 1.875 2.875 1.875H12.125C12.4751 1.875 12.6501 1.875 12.7838 1.94312C12.9014 2.00304 12.9969 2.09866 13.0569 2.21626C13.125 2.34995 13.125 2.52497 13.125 2.875V3.96079C13.125 4.11366 13.125 4.19009 13.1078 4.26202C13.0924 4.32579 13.0672 4.38676 13.0329 4.44268C12.9943 4.50575 12.9402 4.5598 12.8321 4.66789L10.625 6.875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveFilters);
export default __webpack_public_path__ + "static/media/icon-remove-filters.ba022815646dfb35f861a907555b8dc8.svg";
export { ForwardRef as ReactComponent };